document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.bahari-centered-slider-section');

  sections.forEach(function (section) {
    var slider = section.querySelector('.bahari-centered-slider');
    var prev = section.querySelector('.bahari-centered-slider__prev');
    var next = section.querySelector('.bahari-centered-slider__next');

    if (!slider || !prev || !next) return;

    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      console.warn('Slick Slider no está cargado en este theme.');
      return;
    }

    var $slider = window.jQuery(slider);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    var autoplayEnabled = true;
    var autoplaySpeed = 6000;

    var inlineStyle = section.querySelector('style');
    if (inlineStyle) {
      var cssText = inlineStyle.textContent || '';
      var match = cssText.match(/--bahari-slider-autoplay-speed:\s*(\d+)ms/);
      if (match && match[1]) {
        autoplaySpeed = parseInt(match[1], 10);
      }
    }

    $slider.slick({
      autoplaySpeed: autoplaySpeed,
      dots: true,
      dotsClass: 'bahari-dots-linear',
      infinite: true,
      autoplay: autoplayEnabled,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: window.jQuery(prev),
      nextArrow: window.jQuery(next),
      variableWidth: true,
      centerMode: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            variableWidth: true,
            centerMode: true
          }
        }
      ]
    });
  });
});